<script lang="ts">
    import {getLocalization} from 'src/core';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import {getLoanRequestFormContext} from '../../context';

    const localize = getLocalization();
    const {loginAndUpdateForm} = getLoanRequestFormContext();
</script>

<div class="login-first-button-container">
    <KpButton buttonStyle="warning"
              dataQa="login-first-button"
              on:click={loginAndUpdateForm}>
        {localize(/* @kp-localization commons.NejdrivePrihlasit */ 'commons.NejdrivePrihlasit')}
    </KpButton>
</div>

<style lang="less">
    .login-first-button-container {
        align-self: center;
    }
</style>